module.exports = __webpack_public_path__ + "media/application/images/svgs/file-plus-3f672f66ece8809e4d13d96e991a0805.svg";